import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Headers from '../components/Headers'
import QuickActions from '../components/QuickActions'
import Banner from '../components/Banner'
import Categorys from '../components/Categorys'
import FeatureProducts from '../components/products/FeatureProducts'
import FeatureShops from '../components/shops/FeaturedShops'
import Products from '../components/products/Products'
import Footer from '../components/Footer'
import BottomNav from '../components/BottomNav'
import { get_category, get_products, fetchFeaturedSellers } from '../store/reducers/homeReducer'

const Home = () => {
    const dispatch = useDispatch()
    const [mobileView, setMobileView] = useState('categories')
    const {
        products,
        latest_product,
        topRated_product,
        discount_product,
        featuredSellers,
    } = useSelector(state => state.home)

    useEffect(() => {
        dispatch(fetchFeaturedSellers());
        dispatch(get_products());
    }, [dispatch]);

    return (
        <div className='w-full bg-gray-50 pb-0 md-lg:pb-16'>
            <Headers />
            <QuickActions />
            <Banner />

            {/* ── Mobile toggle: Categories ↔ Trending (skeuomorphic) ── */}
            <div className="hidden md-lg:flex justify-center mt-4 mb-1 px-4">
                <div
                    className="inline-flex rounded-2xl p-1.5 gap-1.5"
                    style={{
                        background: 'linear-gradient(180deg, #e8e8e8 0%, #d4d4d4 100%)',
                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.15), 0 1px 0 rgba(255,255,255,0.8)',
                        border: '1px solid rgba(0,0,0,0.08)',
                    }}
                >
                    <button
                        onClick={() => setMobileView('categories')}
                        className="flex items-center gap-1.5 px-5 py-2.5 rounded-xl text-sm font-bold transition-all"
                        style={mobileView === 'categories' ? {
                            background: 'linear-gradient(180deg, #00C05A 0%, #00A651 50%, #008F45 100%)',
                            color: '#fff',
                            boxShadow: '0 3px 8px rgba(0,166,81,0.4), inset 0 1px 0 rgba(255,255,255,0.35), inset 0 -1px 2px rgba(0,0,0,0.15)',
                            textShadow: '0 1px 2px rgba(0,0,0,0.2)',
                            border: '1px solid rgba(0,0,0,0.1)',
                        } : {
                            background: 'transparent',
                            color: '#888',
                            textShadow: '0 1px 0 rgba(255,255,255,0.8)',
                        }}
                    >
                        📂 Categories
                    </button>
                    <button
                        onClick={() => setMobileView('trending')}
                        className="flex items-center gap-1.5 px-5 py-2.5 rounded-xl text-sm font-bold transition-all"
                        style={mobileView === 'trending' ? {
                            background: 'linear-gradient(180deg, #00C05A 0%, #00A651 50%, #008F45 100%)',
                            color: '#fff',
                            boxShadow: '0 3px 8px rgba(0,166,81,0.4), inset 0 1px 0 rgba(255,255,255,0.35), inset 0 -1px 2px rgba(0,0,0,0.15)',
                            textShadow: '0 1px 2px rgba(0,0,0,0.2)',
                            border: '1px solid rgba(0,0,0,0.1)',
                        } : {
                            background: 'transparent',
                            color: '#888',
                            textShadow: '0 1px 0 rgba(255,255,255,0.8)',
                        }}
                    >
                        🔥 Trending
                    </button>
                </div>
            </div>

            {/* Categories — desktop always | mobile when selected */}
            <div className={`my-4 ${mobileView !== 'categories' ? 'md-lg:hidden' : ''}`}>
                <Categorys />
            </div>
            {/* Featured products — desktop always | mobile when selected */}
            <div className={`py-[20px] ${mobileView !== 'trending' ? 'md-lg:hidden' : ''}`}>
                <FeatureProducts products={products} />
            </div>
            <div className='py-[20px]'>
                <FeatureShops shops={featuredSellers} />
            </div>
            <div className='py-10'>
                <div className='w-[90%] md:w-[85%] mx-auto'>
                    <div className="grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7">
                        <div className='overflow-hidden'>
                            <Products title='Latest Product' products={latest_product} />
                        </div>
                        <div className='overflow-hidden'>
                            <Products title='Top Rated Products' products={topRated_product} />
                        </div>
                        <div className='overflow-hidden'>
                            <Products title='On discount' products={discount_product} />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <BottomNav />
        </div>
    )
}

export default Home
